import { Button } from '@consigli/shadcn';
import { ReactNode } from 'react';

import { Modal } from './modal';

interface EditModalProps<T> {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  data: T;
  onDataChange: (data: T) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  children: ReactNode;
  isValid?: boolean;
}

export const EditModal = <T,>({
  isOpen,
  onOpenChange,
  title,
  description,
  data: _data,
  onDataChange: _onDataChange,
  onConfirm,
  onCancel,
  isSubmitting = false,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  children,
  isValid = true,
}: EditModalProps<T>) => (
  <Modal
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    title={title}
    description={description}
    footer={
      <div className="flex gap-2">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
        >
          {cancelLabel}
        </Button>
        <Button
          variant="default"
          onClick={onConfirm}
          disabled={isSubmitting || !isValid}
          className="bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 disabled:opacity-50"
        >
          {isSubmitting ? 'Saving...' : submitLabel}
        </Button>
      </div>
    }
  >
    {children}
  </Modal>
);
